// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page__modal',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    data: () => ({
        _mode: '',
    }),
    props: {
        contextId: {
            type: String,
            required: true,
            default: ''
        },
        itemId: {
            type: String,
            required: false,
            default: ''
        },
        args: {
            type: Object,
            required: false
        },
        mode: {
            type: String,
            required: false,
            default: 'view'
        }
    },
    // #endregion
    // #region Computed
    computed: {
        sMode() {
            return utils.isNullOrEmpty(this._mode) ? this.mode : this._mode;
        },
        oControl() {
            if (this.sMode === 'new' || this.sMode === 'state' || this.sMode === 'edit') {
                return this.$refs['__create'];
            }
            else {
                return this.$refs['__view'];
            }
        },
    },
    // #endregion
    // #region Methods
    methods: {
        async onEdit() {
            this._mode = 'edit';
        },
        async onClose() {
            if (utils.isNullOrEmpty(this._mode)) {
                this.currentWindow.close({ state: 2 });
            }
            else {
                this._mode = '';
            }
        },
        async onCommit() {
            if ((await this.oControl.onCommit())) {
                if (utils.isNullOrEmpty(this._mode)) {
                    this.currentWindow.close({ state: 1 });
                }
                else {
                    this._mode = '';
                }
            }
            else {
                return;
            }
        },
        async onCommand(commandName) {
            await this.oControl?.onCommand(commandName);
        }
    },
    // #endregion
});
// #endregion
